var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H5.625C2.5184 0 0 2.5184 0 5.625V18.375C0 21.4816 2.5184 24 5.625 24H18.375C21.4816 24 24 21.4816 24 18.375V5.625C24 2.5184 21.4816 0 18.375 0Z",
    fill: "#242938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7768C12.966 13.7768 13.749 12.9937 13.749 12.0278C13.749 11.0619 12.966 10.2788 12 10.2788C11.034 10.2788 10.251 11.0619 10.251 12.0278C10.251 12.9937 11.0341 13.7768 12 13.7768Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.47168C14.3484 8.47168 16.5299 8.80862 18.1747 9.37496C20.1565 10.0572 21.375 11.0913 21.375 12.0278C21.375 13.0036 20.0837 14.1023 17.9555 14.8074C16.3465 15.3405 14.2293 15.6187 12.0002 15.6187C9.71475 15.6187 7.55053 15.3575 5.92341 14.8015C3.86484 14.0979 2.625 12.9851 2.625 12.0278C2.625 11.0989 3.78844 10.0727 5.74237 9.39156C7.39331 8.81593 9.62859 8.47168 11.9998 8.47168H12.0002Z",
    stroke: "#00D8FF",
    strokeWidth: 0.556938
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90453 10.2598C10.0777 8.22562 11.4593 6.50419 12.7716 5.36231C14.3526 3.98634 15.8573 3.44747 16.6684 3.91519C17.5138 4.40269 17.8204 6.07031 17.3681 8.26612C17.0264 9.92615 16.2094 11.8992 15.0958 13.8303C13.954 15.8101 12.6467 17.5544 11.3522 18.6858C9.71434 20.1175 8.13081 20.6357 7.30159 20.1575C6.49693 19.6938 6.18925 18.1731 6.57531 16.1401C6.90146 14.4223 7.72 12.314 8.90415 10.2598H8.90453Z",
    stroke: "#00D8FF",
    strokeWidth: 0.556938
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90744 13.8355C7.73097 11.8036 6.92997 9.74649 6.59566 8.0393C6.19319 5.98233 6.47772 4.40968 7.28819 3.94055C8.13278 3.45155 9.73056 4.01874 11.407 5.5073C12.6745 6.63268 13.976 8.32552 15.0929 10.2547C16.2379 12.2326 17.0961 14.2366 17.43 15.9229C17.8524 18.0571 17.5105 19.6876 16.682 20.1672C15.8782 20.6326 14.4072 20.1399 12.8387 18.7901C11.5134 17.6497 10.0955 15.8877 8.90744 13.8355Z",
    stroke: "#00D8FF",
    strokeWidth: 0.556938
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/reactjs.45c9749e3b0cd49764ed3e6d66c0a8f6.svg";
export { ForwardRef as ReactComponent };